import { defineMessages } from 'react-intl'

export const networkStatusClientsMessages = defineMessages({
  wirelessTotalText: {
    id: 'networkStatusClientsMessages.wirelessTotalText',
    description: 'Title text for Wireless Total',
    defaultMessage: 'Wireless',
  },
})
